import { Controller } from '../utils/controller';

export default class extends Controller {
  // targets
  static targets = ['video', 'play', 'pause', 'progressCompleted'];

  declare videoTarget: HTMLVideoElement;
  declare playTarget: SVGElement;
  declare pauseTarget: SVGElement;
  declare progressCompletedTarget: HTMLDivElement;

  // Setup listener for progress
  connect() {
    this.videoTarget.addEventListener('timeupdate', () => {
      const currTime = this.videoTarget.currentTime;
      const duration = this.videoTarget.duration;
      const progressPercent = Math.round((currTime / duration) * 100);
      this.progressCompletedTarget.style.width = progressPercent + '%';
    });
  }

  togglePlay(event: PointerEvent) {
    if (this.videoTarget.paused) {
      this.play(event);
    } else {
      this.pause(event);
    }
  }

  // play the video
  play(event: PointerEvent) {
    event.stopPropagation();
    this.videoTarget.play();
    this.playTarget.classList.add('hidden');
    this.pauseTarget.classList.remove('hidden');
  }

  // pause the video
  pause(event: PointerEvent) {
    event.stopPropagation();
    this.videoTarget.pause();
    this.playTarget.classList.remove('hidden');
    this.pauseTarget.classList.add('hidden');
  }

  // move play position back 5 seconds
  rewind(event: PointerEvent) {
    event.stopPropagation();
    this.videoTarget.currentTime -= 5;
  }

  // move play position ahead 5 seconds
  fastForward(event: PointerEvent) {
    event.stopPropagation();
    this.videoTarget.currentTime += 5;
  }
}
